import { render, staticRenderFns } from "./ActiveFilterListItem.vue?vue&type=template&id=5cfd2889"
import script from "./ActiveFilterListItem.vue?vue&type=script&lang=js"
export * from "./ActiveFilterListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports